import type { LayoutMarginsType, Layouts, RouteWithTitle } from '@pbk-web/types';

import { simpleGlobalState } from './SimpleGlobalState';

export const useLayoutMargins = simpleGlobalState<LayoutMarginsType>({ left: 0 });

export const useCurrentLayout = simpleGlobalState<keyof typeof Layouts | null>(null);

export const useCurrentRouteState = simpleGlobalState<RouteWithTitle | null>(null);
